import React, { Component } from 'react';
import styled from 'styled-components';

import { Box, Flex } from '../../units/Box/Box';
import Text from '../../units/Text/Text';
import Icon from '../../units/Icon/Icon';

const Wrapper = styled(Flex).attrs({
  align: 'center',
  m: '0 0 30px',
  column: true
})``;

const Title = styled(Text).attrs({
  size: '32px',
  bold: true,
  font: 'caption'
})``;

const Description = styled(Text).attrs({
  size: '17px',
  font: 'caption'
})`
  color: ${props => props.theme.colors.grey};
`;

class Header extends Component {
  render() {
    return (
      <Wrapper className="header">
        <Box className="header__logotype" m="40px 0px 10px 0px">
          <Icon width="360px" height="110px" icon="logoNico" />
        </Box>

        <Box m="10px 0">
          <Title className="header__title">Открытие счета</Title>
        </Box>
        <Box>
          <Description className="header__desciption">
            для юридических лиц и индивидуальных предпринимателей
          </Description>
        </Box>
      </Wrapper>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/layout/Header/Header.js